export const wp: JsideaPlugins = {} as any;